import React from 'react'
import './StatusBadge.css'

export const statusConfig = {
  pedido_protocolado: {
    label: 'Pedido protocolado',
    descricao:
      'O pedido foi recebido e numerado pelo INPI. É o ponto de partida do processo — o número de protocolo já existe, mas o exame ainda não começou.',
    className: 'inpi-status-badge inpi-status-protocolado'
  },
  exame_formal: {
    label: 'Exame formal',
    descricao:
      'O INPI está verificando se a documentação está completa e correta. Se aprovado, o pedido será publicado na Revista da Propriedade Industrial (RPI) para conhecimento público.',
    className: 'inpi-status-badge inpi-status-andamento'
  },
  aguardando_oposicao: {
    label: 'Aguard. oposição',
    descricao:
      'O pedido foi publicado na RPI e está dentro do prazo legal de 60 dias em que terceiros podem apresentar oposição ao registro. Nenhuma decisão foi tomada ainda.',
    className: 'inpi-status-badge inpi-status-oposicao'
  },
  aguardando_manifestacao: {
    label: 'Aguard. manifestação',
    descricao:
      'Uma oposição foi apresentada por terceiro. O titular do pedido tem prazo para se manifestar e rebater os argumentos antes do INPI decidir.',
    className: 'inpi-status-badge inpi-status-manifestacao'
  },
  aguardando_merito: {
    label: 'Aguard. mérito',
    descricao:
      'O processo passou pelas etapas formais e aguarda o examinador analisar se a marca, patente ou software atende aos requisitos legais para ser registrada.',
    className: 'inpi-status-badge inpi-status-merito'
  },
  deferido: {
    label: 'Deferido',
    descricao:
      'O INPI aprovou o pedido! O registro foi concedido após análise completa. Em geral, é necessário pagar as taxas de concessão para que o certificado seja emitido.',
    className: 'inpi-status-badge inpi-status-deferido'
  },
  indeferido: {
    label: 'Indeferido',
    descricao:
      'O INPI negou o pedido por não atender aos requisitos legais. Ainda é possível interpor recurso administrativo dentro do prazo estipulado na decisão.',
    className: 'inpi-status-badge inpi-status-indeferido'
  },
  registro_ativo: {
    label: 'Registro ativo',
    descricao:
      'O certificado de registro foi emitido e está em vigor. O direito de exclusividade está garantido pelo prazo legal. Anuidades devem ser pagas para manter o registro ativo.',
    className: 'inpi-status-badge inpi-status-ativo'
  },
  arquivado: {
    label: 'Arquivado',
    descricao:
      'O processo foi encerrado sem concessão do registro, geralmente por falta de pagamento de taxa ou não atendimento de exigência. Pode ser reaberto em alguns casos.',
    className: 'inpi-status-badge inpi-status-arquivado'
  },
  pedido_inexistente: {
    label: 'Pedido inexistente',
    descricao:
      'O INPI considerou o pedido como não existente, geralmente por irregularidade grave no depósito ou não pagamento da taxa básica no ato do protocolo.',
    className: 'inpi-status-badge inpi-status-inexistente'
  }
}

const STATUS_KEYS = Object.keys(statusConfig)

export function normalizeStatus(apiStatus) {
  if (!apiStatus) return 'pedido_protocolado'
  const s = String(apiStatus).toLowerCase()
  if (STATUS_KEYS.includes(s)) return s
  if (/protocolado|protocolo/.test(s)) return 'pedido_protocolado'
  if (/exame.formal|formal/.test(s)) return 'exame_formal'
  if (/oposi[cç][aã]o|oposi/.test(s)) return 'aguardando_oposicao'
  if (/manifesta[cç][aã]o/.test(s)) return 'aguardando_manifestacao'
  if (/m[eé]rito|merito/.test(s)) return 'aguardando_merito'
  if (/deferido/.test(s)) return 'deferido'
  if (/indeferido/.test(s)) return 'indeferido'
  if (/registro.ativo|ativo|certificado|em.vigor|vigor/.test(s)) return 'registro_ativo'
  if (/arquivado/.test(s)) return 'arquivado'
  if (/inexistente/.test(s)) return 'pedido_inexistente'
  if (/an[aá]lise|andamento|em.exame/.test(s)) return 'exame_formal'
  return 'pedido_protocolado'
}

export function StatusBadge({ status }) {
  const key = normalizeStatus(status)
  const config = statusConfig[key] || statusConfig.pedido_protocolado
  return (
    <span className={`${config.className}`}>
      <span className="inpi-status-dot" />
      {config.label}
    </span>
  )
}
